<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="6">
				<el-date-picker style="width: 100%;" v-model="searchInfo.timerange" type="daterange" format="yyyy-MM-dd"
					range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="timeRangeChange">
				</el-date-picker>
				<!-- <el-date-picker style="width: 100%;" v-model="searchInfo.day" type="date" format="yyyy-MM-dd"></el-date-picker> -->
			</el-col>
			<el-col :span="16">
				<el-input clearable placeholder="点位id" v-model="searchInfo.pid">
					<template slot="prepend">id</template>
				</el-input>
			</el-col>
			<el-col :span="2"> 
				<div style="min-width: 200px;">
					<el-button type="primary" @click="searchHisSet" icon="el-icon-search">搜索</el-button>
				</div>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<div style="max-height: 380px;overflow: auto;margin-top: 10px;">
				<div style="font-size: 16px;margin-bottom: 10px;">变化数据：</div>
				<div>
					<div style="width: 280px;float: left;padding: 10px;border: 1px solid lightgrey;" v-for="(data,idx) in dataList" :key="idx">
						<!-- <div style="font-size: 14px;">{{data.keyid}}</div> -->
						<div style="font-size: 14px;text-align: center;" >
							<el-tooltip class="item" effect="dark" :content="data.keyid" placement="top">
								<span>{{data.name}}</span> 
							</el-tooltip>
						</div>
						<div style="font-size: 14px;text-align: center;" >
							<span style="color: red;">{{data.offtimes}}</span>
						</div>
						<div style="max-height: 300px;overflow: auto;">
							<div style="padding: 10px;border-bottom: 1px solid lightgrey;font-size: 14px;" v-for="(day,idx) in data.rundata" :key="idx">
								<span :style="{color: day.times == -99998 ? 'red' : '#000'}">{{day.day}}</span>
								<span :style="{color: day.times == -99998 ? 'red' : '#000', marginLeft: '10px'}">值：{{day.times}}</span>
							</div>
						</div>
					</div>
					<div style="clear: both;"></div>
				</div>
			</div>
			<div style="max-height: 500px;overflow: auto;margin-top: 10px;">
				<div style="font-size: 16px;margin-bottom: 10px;">原始数据：</div>
				<div style="padding: 10px;border-bottom: 1px solid lightgrey;font-size: 12px;" v-for="(data,idx) in orageList" :key="idx">
					<span style="">{{data.time}}</span>
					<span style="margin-left: 10px;">{{data.value}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { queryPointsHis } from '/static/apiUrl.js'
	export default {
		name : 'PointHistory',
		data() {
			return {
				searchInfo: {
					daybegin : '',
					dayend: '',
					pid : '',
					timerange : '',
				},
				orageList : [],
				dataList : [],
			}
		},
		mounted() {
			
		},
		components: {
		},
		methods: {
			searchHisSet(){
				this.queryHisList()
			},
			timeRangeChange(e){
				this.searchInfo.daybegin = this.$formatDate(e[0],'yyyy-MM-dd')
				this.searchInfo.dayend = this.$formatDate(e[1],'yyyy-MM-dd')
				//console.log(this.searchInfo)
			},
			clearSearch(){
				this.searchInfo.daybegin = ''
				this.searchInfo.dayend = ''
				this.searchInfo.pid = ''
				this.searchInfo.timerange = ''
				this.queryHisList()
			},
			queryHisList(){
				this.dataList = []
				this.orageList = []
				if(this.searchInfo.daybegin == '' || this.searchInfo.pid == '' || this.searchInfo.dayend == ''){
					this.$message({
						showClose: true,
						message: "请输入查询参数",
						type: 'error'
					});
					return
				}
				queryPointsHis({
					daybegin: this.$formatDate(this.searchInfo.daybegin,'yyyy-MM-dd'),
					dayend: this.$formatDate(this.searchInfo.dayend,'yyyy-MM-dd'),
					pointids : this.searchInfo.pid.split(",")
				}).then(res => {
					if(0 == res.code){
						//this.dataList = res.datas.list
						res.datas.list.forEach((item) => {
							let offtimes = 0
							item.rundata.forEach((vl) => {
								if(vl.times == -99998){
									offtimes++
								}
							})
							this.dataList.push({
								keyid : item.keyid,
								name : item.name,
								rundata : item.rundata,
								offtimes : offtimes
							})
							console.log(item.keyid,item.name,offtimes )
						})
						let keys = Object.keys(res.datas.orage)
						let vs = Object.values(res.datas.orage)
						keys.forEach((key,idx) => {
							this.orageList.push({
								time: key.substring(0,19),
								value: vs[idx]
							})
						})
					}
				})
			},
			
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>